module.exports = __webpack_public_path__ + "img/RAP.de82dcfc.svg";